import track_promise from "../../utils/track_promise"
import { Engine } from "./Engine"

export const {
  MergePdf,
  PlotPdf,
  RasterizePdf,
  SplitPdf,
  ZipFiles,
  GenerateFile,
  CreateRemoteFile,
} = Engine

export const RequestContent = f =>
  track_promise(emit => Engine.RequestContent(f, emit))
